/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAsterisk = createReactComponent("outline", "asterisk", "IconAsterisk", [["path", { "d": "M12 12l8 -4.5", "key": "svg-0" }], ["path", { "d": "M12 12v9", "key": "svg-1" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-2" }], ["path", { "d": "M12 12l8 4.5", "key": "svg-3" }], ["path", { "d": "M12 3v9", "key": "svg-4" }], ["path", { "d": "M12 12l-8 4.5", "key": "svg-5" }]]);

export { IconAsterisk as default };
//# sourceMappingURL=IconAsterisk.mjs.map
